<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar v-show="!offlineSubmit" flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title> {{ $t(type + "Cash") }} </v-toolbar-title>
      <v-radio-group v-model="type" class="mt-6" row>
        <v-radio :label="$t('payCash')" value="pay" :disabled="id ? true : false" />
        <v-radio
          :label="$t('recieveCash')"
          value="recieve"
          :disabled="id ? true : false"
        />
      </v-radio-group>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="goTo(type + 'List')">
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type + "List") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="$router.go(-1)">
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t("public-information") }}
        </v-tab>
        <v-tab :disabled="!documentPermmission">
          {{ $t("documents") }}
        </v-tab>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col v-show="!offlineSubmit" class="px-3 xs" cols="12" md="3" sm="3">
                <autocomplete
                  ref="refAccount"
                  v-model="account"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :title="type == 'pay' ? $t('reciever') : $t('payer')"
                  type="person"
                  :new-btn="true"
                  :value="account"
                />
              </v-col>
              <v-col v-if="currency" class="px-3 xs" cols="12" md="3" sm="3">
                <autocomplete
                  ref="refBank"
                  v-model="bank"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :title="$t('bank') + '/' + $t('cash')"
                  :currency-prop="currency.id"
                  type="bankCash"
                />
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <template>
                  <v-text-field
                    id="from"
                    v-model="date"
                    :label="$t('date')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />
                  <date-picker
                    v-model="date"
                    element="from"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="
                      this.$vuetify.theme.themes[
                        this.$vuetify.theme.isDark ? 'dark' : 'light'
                      ].primary
                    "
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <money
                  v-model="amount"
                  :label="$t('amount')"
                  :dense="true"
                  :outlined="true"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  :value-options="{
                    max: bank
                      ? Number(bank.remain.currency_remain) + parseFloat(this.editPrice)
                      : 9999999999999999999,
                  }"
                  @SetValueMax="SetValueMaxPrice()"
                />
              </v-col>
              <v-col class="px-3 xs pb-0" cols="12" md="3" sm="3">
                <v-chip
                  class="mx-0"
                  :color="remianColor"
                  label
                  style="width: 100%"
                  outlined
                >
                  {{ $t("remain") }} {{ $t("customer") }} :
                  {{
                    $numberFormat(
                      parseFloat(
                        personInfo && personInfo.remain ? personInfo.remain.remain : 0
                      )
                    )
                  }}
                  {{ currency ? currency.name : "" }}
                </v-chip>
              </v-col>
              <v-col
                v-show="type !== 'recieve'"
                class="px-3 xs pb-0"
                cols="12"
                md="3"
                sm="3"
              >
                <v-chip
                  class="mx-0"
                  :color="remianBankColor"
                  label
                  style="width: 100%"
                  outlined
                >
                  {{ $t("remain") }} {{ $t("bank") + "/" + $t("cash") }} :
                  {{ $numberFormat(parseFloat(bankRemain)) }}
                  {{ currency ? currency.name : "" }}
                </v-chip>
              </v-col>
            </v-row>
            <v-expansion-panels v-model="panel" class="mt-7 px-0">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t("otherInputs") }}
                  ✏️
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col class="px-3 xs" cols="12" md="2" sm="2">
                      <autocomplete
                        v-model="branch"
                        :title="$t('branch')"
                        type="branch"
                        :set-init="true"
                        :value="branch"
                      />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                      <autocomplete
                        ref="refCurrency"
                        v-model="currency"
                        :rules="[(v) => !!v || $t('is-required')]"
                        :title="$t('currency')"
                        type="currency"
                        :value="currency"
                        :init="defaultCurrency"
                        @change="changeCurrency"
                        @clear="changeCurrency"
                      />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                      <money
                        v-model="currency_amount"
                        :label="$t('currency-rate')"
                        :dense="true"
                        :outlined="true"
                        :rules="[(v) => !!v || $t('is-required')]"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty=""
                        :options="options"
                      />
                    </v-col>
                    <v-col cols="12" md="2" sm="2">
                      <autocomplete
                        v-model="given"
                        :title="$t('accountGiven')"
                        type="given"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="issueTracking"
                        :label="$t('issueTracking')"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <tag v-model="tag" :solo="false" :input="tag" :height="25" />
                    </v-col>
                    <v-col class="px-3 xs" cols="12" md="4" sm="4">
                      <autocomplete
                        ref="refRelations"
                        v-model="relations"
                        :multiple="true"
                        :value="relations"
                        :disabled="!account ? true : false"
                        :data="
                          JSON.stringify({
                            refId: account ? account.id : null,
                            currency_id: currency ? currency.id : null,
                          })
                        "
                        :title="$t('relative-document')"
                        :type="type == 'pay' ? 'receiptInvoice' : 'remittanceInvoice'"
                      />
                    </v-col>
                    <v-col class="px-3 xs" cols="12" md="2" sm="2">
                      <v-chip
                        label
                        dark
                        small
                        outlined
                        style="width: 100%; height: 32px"
                        class="mx-0"
                        color="orange"
                      >
                        {{ $t("sum-of-selected-documents") }} :
                        {{ $numberFormat(sumRelations) }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" md="6">
                      <description
                        ref="refDescription"
                        v-model="description"
                        :outlined="true"
                        type="sell"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col cols="12" md="3" sm="3">
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="payment"
                :val="id && attachments ? attachments : null"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6" class="px-1">
            <v-btn
              v-if="
                !id &&
                !isMobile &&
                type === 'recieve' &&
                $store.state.allConfig &&
                $store.state.allConfig.posMethod
              "
              v-shortkey="['f6']"
              color="teal"
              height="40"
              class="me-2"
              :loading="isLoading"
              @shortkey="sendToPos"
              @click="sendToPos"
            >
              {{ $t("pos&submit") }} (f6)
            </v-btn>
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t("submit") }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2" />
        </v-row>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p style="color: white" class="text-center">
            {{ !lodingText ? $t("syncData") : $t(lodingText) }} ...
          </p>
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import Combobox from '../../components/general/combobox/Combobox'
import autocomplete from "../../components/general/patial/autocomplete";
import Description from "../../components/general/description/Description";
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
export default {
  name: "Customer",
  components: {
    // Combobox,
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete,
    filePicker,
    Description,
  },
  mixins: [General],
  props: ["typeForm", "accountProp", "typeProp", "notStore", "offlineSubmit"],
  data: () => ({
    valid: true,
    dateFormat: "YYYY/MM/DD",
    loadingDialog: false,
    paymentByPos: null,
    lodingText: null,
    more: true,
    currency: null,
    attachments: null,
    defaultCurrency: null,
    issueTracking: null,
    accountGiven: null,
    bankGiven: null,
    id: null,
    extra: false,
    relations: null,
    given: null,
    snakbar: null,
    snakbarText: null,
    snakbarColor: null,
    sumRelations: null,
    currency_amount: 1,
    tag: null,
    remianBankColor: "blue",
    remianColor: "blue",
    customerId: null,
    bankRemain: null,
    taxStatus: null,
    taxStatusItems: null,
    clearing: null,
    snackbarShow: null,
    amount: 0,
    editPrice: 0,
    type: null,
    NetPrice: 0,
    taxAmount: 0,
    tax: 9,
    discount: 0,
    taxFeilds: null,
    discountFeilds: null,
    account: null,
    options: {
      locale: "en-US",
      prefix: "",
      suffix: "  ",
      precision: 0,
    },
    optionsTax: {
      locale: "en-US",
      prefix: "",
      suffix: "  %  ",
      precision: 0,
    },
    detail: null,
    bank: null,
    remianLable: null,
    description: null,
    date: null,
    render: true,
    isLoading: false,
  }),
  computed: {
    sum() {
      if (this.taxStatus === "notAdd") {
        return (
          parseFloat(this.price) - parseFloat(this.discount) + parseFloat(this.editPrice)
        );
      } else {
        return (
          parseFloat(this.price) - parseFloat(this.discount) + parseFloat(this.taxAmount)
        );
      }
    },
  },
  watch: {
    defaultCurrency() {
      if (this.defaultCurrency) {
        this.$refs.refCurrency.setModel(this.defaultCurrency);
        this.currency_amount = this.defaultCurrency.amount;
      }
    },
    bank() {
      if (this.render) {
        this.bankRemainCheckPage();
      }
    },
    account(val) {
      this.remianLable = null;
      this.remianColor = "blue";
      if (this.account && this.account.remain && this.account.remain.remain > 0) {
        this.remianColor = "pink";
        this.remianLable = this.$t("debtor");
      }
      if (this.account && this.account.remain && this.account.remain.remain < 0) {
        this.remianColor = "green";
        this.remianLable = this.$t("creditor");
      }
      if (this.$refs.refRelations) {
        this.$refs.refRelations.initList = false;
        this.relations = null;
        this.$refs.refRelations.clear();
        this.$refs.refRelations.getItems();
      }
      if (val) {
        this.getPersonInfo(val.id);
      }
    },
    currency(val) {
      if (!this.id) {
        this.amount = 0;
        this.bankRemain = 0;
        this.currency_amount = this.currency ? this.currency.amount : 1;
      } else {
        if (!val) {
          this.currency = this.$store.state.currency;
          this.bank = null;
        }
      }
    },
    relations() {
      var sum = 0;
      this.relations.map(function (item) {
        sum = parseFloat(sum) + parseFloat(item.price);
      });
      this.sumRelations = sum;
    },
  },
  beforeMount() {
    this.type = this.$route.name;
    this.setInitProp();
    if (this.$route.params.id != null && !this.accountProp) {
      this.show();
      this.id = this.$route.params.id;
      this.render = false;
    } else {
      this.render = true;
      this.defaultCurrency = this.getDefault("defaultCurrency");
    }
    if (this.$store.state.currency && !this.id) {
      this.setInitCurrency();
    }
  },
  mounted() {
    this.setDate();
    this.taxStatusItems = [
      {
        value: "add",
        text: this.$t("add-tax-to-price"),
      },
      {
        value: "notAdd",
        text: this.$t("calculate-tax-on-price"),
      },
    ];
    this.taxStatus = "notAdd";
  },
  methods: {
    setInitProp() {
      if (this.accountProp) {
        this.account = this.accountProp;
      }
      if (this.typeProp) {
        this.type = this.typeProp;
      }
    },
    setInitCurrency() {
      this.currency = this.$store.state.currency;
      this.currency_amount = this.$store.state.currency.amount;
    },
    changeCurrency() {
      this.bankRemain = 0;
      this.currency_amount = this.currency.amount;
      this.options = {
        locale: "en-US",
        prefix: "",
        suffix: this.currency.name,
        precision: 0,
      };
    },
    SetValueMaxPrice() {
      if (this.render && this.type === "pay") {
        // this.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
        // this.snakbarColor = 'pink'
        // this.snakbar = true
        // this.amount = 0
      }
    },
    bankRemainCheckPage() {
      if (this.render && this.bank && this.type === "pay") {
        if (this.$route.params.id != null) {
          this.bankRemain =
            parseFloat(
              this.bank.currency_id === this.$store.state.currency.id
                ? this.bank.remain.remain
                : this.bank.remain.currency_remain
            ) +
            parseFloat(this.editPrice) -
            parseFloat(this.amount);
        } else {
          this.bankRemain =
            parseFloat(
              this.bank.currency_id === this.$store.state.currency.id
                ? this.bank.remain.remain
                : this.bank.remain.currency_remain
            ) - parseFloat(this.amount);
        }
        this.remianBankColor = "grey";
        if (this.bankRemain > 0) {
          this.remianBankColor = "green";
        }
        if (this.bankRemain < 0) {
          this.remianBankColor = "pink";
        }
        if (
          this.bank &&
          parseFloat(this.amount) >
            parseFloat(
              this.bank.currency_id === this.$store.state.currency.id
                ? this.bank.remain.remain
                : this.bank.remain.currency_remain
            ) +
              parseFloat(this.editPrice)
        ) {
          this.amount = 0;
          this.bankRemain =
            parseFloat(
              this.bank.currency_id === this.$store.state.currency.id
                ? this.bank.remain.remain
                : this.bank.remain.currency_remain
            ) +
            parseFloat(this.editPrice) -
            parseFloat(this.amount);
          this.snakbarText = this.$t("alert-pay-amount-bigger-than-bank-remain");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      }
    },
    SetValueMaxDiscount() {
      this.discount = this.price;
    },
    create() {
      if (!this.$refs.form.validate()) return false;
      if (this.offlineSubmit) {
        this.$emit("input", this.$data);
        return false;
      }
      // if (parseFloat(this.bank.remain) - parseFloat(this.price) < 0) {
      //   this.bankRemainCheckPage()
      //   return false
      // }
      var app = this;
      if (this.notStore) {
        const copy = Object.assign({}, this.$data);
        app.$emit("get", copy);
        app.$emit("close");
        this.clearForm();
        this.setInitProp();
      } else {
        app.isLoading = true;
        app.$axios
          .post(this.$endpoint + "payments", this.$data)
          .then((res) => {
            res = res.data;
            app.snakbarText = app.$t("registered");
            app.snakbarColor = "green";
            app.snakbar = true;
            if (app.$refs.refFilePicker !== undefined && app.attachments) {
              app.$refs.refFilePicker.create(res.data.id);
            }
            app.$emit("close", app.$route);
            app.goTo(app.type + "List");
          })
          .catch((err) => {
            if (err.response && err.response.status === 409) {
              this.$store.commit("SET_PLAN_DIALOG", true);
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
            // this.clearForm()
          });
      }
    },
    update() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .put(this.$endpoint + "payments/" + this.$route.params.id, this.$data)
        .then((res) => {
          res = res.data;
          if (app.$refs.refFilePicker !== undefined) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          app.$emit("close", app.$route);
          app.goTo(app.type + "List");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "payments/" + this.$route.params.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.currency = res.currency;
            app.currency_amount = res.currency_amount;
            app.type = res.type;
            app.bankRemain = parseFloat(res.bank.remain.currency_remain);
            app.id = res.id;
            app.attachments = res.attachments;
            app.issueTracking = res.issue_tracking;
            app.branch = res.branch;
            app.amount = res.amount;
            app.editPrice = res.amount;
            app.account = res.account;
            app.given = res.given;
            app.bank = res.bank;
            app.date = res.date;
            app.description = res.content;
            if (res.tags) {
              app.tag = res.tags;
              app.more = true;
            }
            app.relations = res.relations;
            app.render = true;
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    sendToPos() {
      var app = this;
      if (!this.$refs.form.validate()) return false;
      app.lodingText = app.$t("waitingTogetDataFromPOS");
      app.isLoading = true;
      app.loadingDialog = true;
      const socket = new WebSocket("ws://127.0.0.1:4022/PardakhtNovin_S800_Payment");
      socket.onopen = function (event) {
        socket.send(app.amount);
      };
      socket.onmessage = function (event) {
        var data = JSON.parse(event.data);
        if (data.ResponseCode !== "00") {
          app.isLoading = false;
          app.lodingText = null;
          app.loadingDialog = false;
          app.snakbarText = data.description;
          app.snakbarColor = "pink";
          app.snakbar = true;
        } else {
          app.paymentByPos = "active";
          app.create();
        }
        socket.close();
      };
    },
    clearForm() {
      this.more = true;
      this.paymentByPos = null;
      this.defaultCurrency = null;
      this.accountGiven = null;
      this.loadingDialog = false;
      this.lodingText = null;
      this.bankGiven = null;
      this.attachments = null;
      this.id = null;
      this.extra = false;
      this.relations = null;
      this.snakbar = null;
      this.snakbarText = null;
      this.snakbarColor = null;
      this.sumRelations = null;
      this.currency_amount = 1;
      this.tag = null;
      this.remianBankColor = "blue";
      this.remianColor = "blue";
      this.customerId = null;
      this.bankRemain = null;
      this.taxStatus = null;
      this.clearing = null;
      this.snackbarShow = null;
      this.amount = 0;
      this.editPrice = 0;
      this.type = null;
      this.NetPrice = 0;
      this.taxAmount = 0;
      this.tax = 9;
      this.discount = 0;
      this.taxFeilds = null;
      this.discountFeilds = null;
      this.account = null;
      this.detail = null;
      this.bank = null;
      this.remianLable = null;
      this.description = null;
      // this.date = null
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style scoped>
.col {
  height: 55px !important;
}
</style>
